/**
 * Bottom part of header, shows progress of web-app according current screen
 */
import { LitElement, customElement, html } from 'lit-element';

/**
 * LitElement
 * A simple base class for creating fast, lightweight web components.
 *
 * @docs https://lit-element.polymer-project.org/
 */

@customElement('custom-progress-bar')
class CustomProgressBarComponent extends LitElement {
  static get properties() {
    return {
      items: { type: Array },
      progress: { type: Number },
    };
  }

  constructor() {
    super();
    this.progress = 0;

    this.routeChangeEvent = (kasko) => this.routeChanged(kasko.current?.path);
  }

  connectedCallback() {
    if (!process.env.IS_TEST) {
      super.connectedCallback();
    }

    if (!Array.isArray(this.items) || !this.items.length) {
      throw new Error(
        '`items` prop must be defined and must be a non-empty array in `custom-progress-bar` component.',
      );
    }

    this.items.forEach((item) => {
      if (!item) {
        throw new Error(
          'Every element of `items` array must be truthy in `custom-progress-bar` component.',
        );
      }
    });

    this.kasko.addEventListener('route-changed', this.routeChangeEvent);
  }

  firstUpdated() {
    super.firstUpdated();

    const { url } = this.kasko.getState('route').state;

    if (url === '/access-pin' || url.includes('summary')) {
      this.setActiveItems(2);
      return;
    }

    this.items.forEach((item, index) => {
      if (`/${item}` === url || `/${item.screen}` === url) {
        this.setActiveItems(index);
      }
    });
  }

  render() {
    return html`
      <div class="progress-webapp progress">
        ${this.items.map((item) => {
          if (
            item.visibility_condition &&
            !this.kasko.evaluateJsonLogic(item.visibility_condition.schema)
          ) {
            return null;
          }
          return html`
            <div class="step progress-bar">
              <div class="progress-bar-warning">&nbsp;</div>
            </div>
          `;
        })}
      </div>
    `;
  }

  disconnectedCallback() {
    this.kasko.removeEventListener('route-changed', this.routeChangeEvent);
    super.disconnectedCallback();
  }

  setActiveItems(i) {
    this.querySelectorAll('.progress-bar-warning').forEach((element, index) => {
      if (index <= i) {
        element.classList.add('active');
        return;
      }
      element.classList.remove('active');
    });
  }

  routeChanged(path) {
    const visibleItems = this.items.filter((item) => {
      if (
        item.visibility_condition &&
        !this.kasko.evaluateJsonLogic(item.visibility_condition.schema)
      ) {
        return false;
      }

      return true;
    });

    visibleItems.forEach((item, index) => {
      if (path === item || path === item.screen) {
        this.setActiveItems(index);
      }
    });
  }

  createRenderRoot() {
    return this;
  }
}

export default CustomProgressBarComponent;
